import { render, staticRenderFns } from "./DashboardCompanyBoard.vue?vue&type=template&id=63f3e78d&scoped=true&"
import script from "./DashboardCompanyBoard.vue?vue&type=script&lang=js&"
export * from "./DashboardCompanyBoard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCompanyBoard.vue?vue&type=style&index=0&id=63f3e78d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f3e78d",
  null
  
)

export default component.exports